import profile from './assets/computer-img.jpg';
const data = [
  {
    id: 1,
    title: 'Blue Cross of India App',
    details:
      "This is my favourite project which i did in my college second year. It's an Online Dog Adoption app",
    imageUrl: profile,
  },
  {
    id: 2,
    title: 'SpaceX App',
    details:
      "This is my favourite project which i did in my college second year. It's an Online Dog Adoption app",
    imageUrl: profile,
  },
  {
    id: 3,
    title: 'Zoho Employee Case Study',
    details:
      "This is my favourite project which i did in my college second year. It's an Online Dog Adoption app",
    imageUrl: profile,
  },
  {
    id: 4,
    title: 'Siemens Invoice Creator',
    details:
      "This is my favourite project which i did in my college second year. It's an Online Dog Adoption app",
    imageUrl: profile,
  },
  {
    id: 5,
    title: 'Howdy Cast',
    details:
      "This is my favourite project which i did in my college second year. It's an Online Dog Adoption app",
    imageUrl: profile,
  },
  {
    id: 6,
    title: 'Flash News',
    details:
      "This is my favourite project which i did in my college second year. It's an Online Dog Adoption app",
    imageUrl: profile,
  },
];

export default data;
